import NestedForm from 'stimulus-rails-nested-form';

export default class extends NestedForm {
  static targets = ["question", "error"];

  connect() {
    super.connect();
    this.maxQuestions = 10;
  }

  add(event) {
    if (this.questionTargets.length >= this.maxQuestions) {
      event.preventDefault();
      this.showError();
    } else {
      this.hideError();
      super.add(event);
    }
  }

  showError() {
    this.errorTarget.classList.remove("hidden");
  }

  hideError() {
    this.errorTarget.classList.add("hidden");
  }
}